var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.78457 10.87C9.68457 10.86 9.56457 10.86 9.45457 10.87C7.07457 10.79 5.18457 8.84 5.18457 6.44C5.18457 3.99 7.16457 2 9.62457 2C12.0746 2 14.0646 3.99 14.0646 6.44C14.0546 8.84 12.1646 10.79 9.78457 10.87Z",
    stroke: "#CCD1D1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0353 4C18.9753 4 20.5353 5.57 20.5353 7.5C20.5353 9.39 19.0353 10.93 17.1653 11C17.0853 10.99 16.9953 10.99 16.9053 11",
    stroke: "#CCD1D1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78473 14.56C2.36473 16.18 2.36473 18.82 4.78473 20.43C7.53473 22.27 12.0447 22.27 14.7947 20.43C17.2147 18.81 17.2147 16.17 14.7947 14.56C12.0547 12.73 7.54473 12.73 4.78473 14.56Z",
    stroke: "#CCD1D1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9648 20C19.6848 19.85 20.3648 19.56 20.9248 19.13C22.4848 17.96 22.4848 16.03 20.9248 14.86C20.3748 14.44 19.7048 14.16 18.9948 14",
    stroke: "#CCD1D1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.8a7fbbfe26b56d86c1082acc7bc4700b.svg";
export { ForwardRef as ReactComponent };